import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { LayoutDashboard, Users, ArrowLeftRight, Send, FileText, ShieldCheck, Menu, UserPlus, RefreshCw } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const NAV = [
  { to: "/", label: "Panel", icon: LayoutDashboard, id: "dashboard", end: true },
  { to: "/clientes", label: "Clientes", icon: Users, id: "clientes", end: true },
  { to: "/clientes/nuevo", label: "Alta de cliente", icon: UserPlus, id: "alta-cliente" },
  { to: "/transacciones", label: "Transacciones", icon: ArrowLeftRight, id: "transacciones" },
  { to: "/transferencias", label: "SPEI / STP", icon: Send, id: "transferencias" },
  { to: "/estados-cuenta", label: "Estados de cuenta", icon: FileText, id: "estados-cuenta" },
  { to: "/actualizar", label: "Actualizar datos", icon: RefreshCw, id: "actualizar" },
  { to: "/usuarios", label: "Administradores", icon: ShieldCheck, id: "usuarios" },
];

export const Logo = ({ className = "h-9" }) => <img src="/brand/logo.jpeg" alt="e-Plata" className={`${className} w-auto mix-blend-multiply`} data-testid="eplata-logo" />;

const NavItems = ({ onNav }) => (
  <nav className="flex flex-col gap-1">
    {NAV.map(({ to, label, icon: Icon, id, end }) => (
      <NavLink key={to} to={to} end={end} onClick={onNav} data-testid={`nav-${id}`}
        className={({ isActive }) => `flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-teal-600 text-white font-medium shadow-sm" : "text-slate-600 hover:bg-teal-50 hover:text-teal-800"}`}>
        <Icon className="h-4 w-4" /> {label}
      </NavLink>
    ))}
  </nav>
);

export default function Layout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-slate-50">
      <aside className="fixed inset-y-0 left-0 hidden w-64 flex-col justify-between border-r border-slate-200 bg-white p-5 lg:flex">
        <div className="space-y-8">
          <Logo className="h-10" />
          <NavItems />
        </div>
      </aside>
      <div className="lg:pl-64">
        <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-slate-200 bg-white/80 px-4 backdrop-blur-md lg:px-8">
          <div className="flex items-center gap-3">
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <button className="rounded-md p-2 hover:bg-slate-100 lg:hidden" data-testid="mobile-menu-btn"><Menu className="h-5 w-5" /></button>
              </SheetTrigger>
              <SheetContent side="left" className="w-72 bg-white">
                <SheetTitle className="sr-only">Menú</SheetTitle>
                <div className="space-y-8 pt-2"><Logo className="h-9" /><NavItems onNav={() => setOpen(false)} /></div>
              </SheetContent>
            </Sheet>
            <div className="lg:hidden"><Logo className="h-7" /></div>
            <span className="hidden text-xs font-medium uppercase tracking-[0.2em] text-slate-400 lg:block">Back-office · Fondos de Pago Electrónico</span>
          </div>
          <div data-testid="user-menu"><UserButton /></div>
        </header>
        <main className="mx-auto max-w-[1400px] space-y-8 p-4 sm:p-6 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
